import warn from './warn';

export default (componentName: string, oldProp: string, newProp: string) => {
  warn(
    `${componentName}: ${oldProp} is deprecated and will be removed, use ${newProp} instead`
  );
};
